export enum GridNames {
  Payment = "Payment",
  Subscription = "Subscription",
  Invoice = "Invoice",
  PaymentMethod = "PaymentMethod",
  Contact = "Contact",
  Checkout = "Checkout",
  Item = "Item",
  Service = "Service",
  Donation = "Donation",
  Donors = "Donors",
  Product = "Product",
  Membership = "Membership",
  Order = "Order",
  PayOuts = "PayOuts",
}

export enum IFRAMEMessageTypes {
  PreviewMessageDataReceived  = "checkout-preview-data-received",
  CheckOutPreviewData = "checkout-preview",
  CheckOutDetailPreivewData = "checkout-detail-preview",
}
